import axios from 'axios';
import { Service } from 'axios-middleware';
import { getSessionToken } from "@shopify/app-bridge/utilities";
const service = new Service(axios);

service.register({
    onRequest(config) {
        if (window.shopifyApp) {
            return getSessionToken(window.shopifyApp) // requires an App Bridge instance
                .then(token => {
                    // append your request headers with an authenticated token
                    config.headers["Authorization"] = `Bearer ${token}`;
                    return config;
                }).catch(err => {
                    console.log("Unable to get shopify token", err)
                });
        }
        return config;
    },
    onSync(promise) {
        return promise;
    },
    onResponse(response) {
        return response;
    }
});

console.log('Ready to fetch.');